import React from 'react';
import { isMobile } from 'react-device-detect';
import { ChatHeading } from 'services/api/chatsApi';
import styled from 'styled-components';

interface HeadingSectionProps {
  heading: ChatHeading[];
}

const HeadingSection: React.FC<HeadingSectionProps> = ({ heading }) => {
  if (!heading || heading.length === 0) return null;

  if (isMobile) {
    return (
      <HeadingSectionWrapper>
        {heading.map((item, index) => (
          <MobileHeadingCard key={index}>
            <MobileHeadingContent>
              <HeadingTextBlock>
                <HeadingTitle>{item.title}</HeadingTitle>
                <HeadingDescription>{item.description}</HeadingDescription>
              </HeadingTextBlock>
              <HeadingImageBlock>
                <HeadingImage
                  src={item.coverUrl}
                  alt={item.title}
                />
              </HeadingImageBlock>
            </MobileHeadingContent>
          </MobileHeadingCard>
        ))}
      </HeadingSectionWrapper>
    );
  }

  return (
    <HeadingSectionWrapper>
      {heading.map((item, index) => (
        <HeadingCard key={index} $isEven={index % 2 === 0}>
          <HeadingContent $isEven={index % 2 === 0}>
            <HeadingImageBlock>
              <HeadingImage
                src={item.coverUrl}
                alt={item.title}
              />
            </HeadingImageBlock>
            <HeadingTextBlock>
              <HeadingTitle>{item.title}</HeadingTitle>
              <HeadingDescription>{item.description}</HeadingDescription>
            </HeadingTextBlock>
          </HeadingContent>
        </HeadingCard>
      ))}
    </HeadingSectionWrapper>
  );
};

export default HeadingSection;

const HeadingSectionWrapper = styled.section`
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  
  @media (max-width: 968px) {
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const HeadingCard = styled.div<{ $isEven: boolean }>`
  width: 100%;
`;

const HeadingContent = styled.div<{ $isEven: boolean }>`
  display: flex;
  align-items: center;
  background: #1D1D1D;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  min-height: 420px;
  overflow: hidden;
  
  flex-direction: ${props => props.$isEven ? 'row' : 'row-reverse'};
  
  @media (max-width: 968px) {
    flex-direction: column;
    min-height: auto;
    text-align: center;
  }
`;

const MobileHeadingCard = styled.div`
  width: 100%;
`;

const MobileHeadingContent = styled.div`
  display: flex;
  flex-direction: column;
  background: #1D1D1D;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  padding: 24px;
  gap: 16px;
`;

const HeadingImageBlock = styled.div`
  flex-shrink: 0;
  width: 420px;
  height: 420px;
  
  @media (max-width: 968px) {
    width: 100%;
    height: 200px;
  }
`;

const HeadingImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #2A2A2A;
  border-radius: 12px;
  
  @media (max-width: 968px) {
    border-radius: 12px;
  }
`;

const HeadingTextBlock = styled.div`
  flex: 1;
  min-width: 0;
  padding: 32px;
  
  @media (max-width: 968px) {
    padding: 0;
    text-align: left;
  }
`;

const HeadingTitle = styled.h2`
  font-size: 24px;
  line-height: 28px;
  font-family: Raleway;
  font-weight: 700;
  color: #FFF;
  margin-bottom: 16px;

  @media (max-width: 720px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

const HeadingDescription = styled.p`
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #E5E5E5;
  
  @media (max-width: 720px) {
    font-size: 14px;
    line-height: 18px;
  }
`; 